export default "__VITE_ASSET__4afc930f__"